var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
var SpaceItem = /** @class */ (function (_super) {
    __extends(SpaceItem, _super);
    function SpaceItem(props) {
        return _super.call(this, props) || this;
    }
    SpaceItem.prototype.normalizationSize = function (size) {
        var newSize = Array.isArray(size) ? size : [size, size];
        newSize = newSize.map(function (item) {
            return item | 0;
        });
        return newSize;
    };
    SpaceItem.prototype.render = function () {
        var _a = this.props, size = _a.size, direction = _a.direction, wrap = _a.wrap, split = _a.split, latestIndex = _a.latestIndex, children = _a.children, index = _a.index, unit = _a.unit;
        var _b = __read(this.normalizationSize(size), 2), horizontalSize = _b[0], verticalSize = _b[1];
        var style = {};
        if (direction == 'vertical') {
            style = index == latestIndex ? {} : { marginBottom: horizontalSize / (split ? 2 : 1) + unit };
        }
        else {
            style = __assign(__assign({}, (index < latestIndex && { marginRight: horizontalSize / (split ? 2 : 1) + unit })), (wrap && { paddingBottom: verticalSize + unit }));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(DivTag, { style: style }, children),
            split && index < latestIndex && (React.createElement(SpanTag, { atomics: [], style: style }, split))));
    };
    SpaceItem.defaultProps = defaultProps;
    return SpaceItem;
}(PureComponent));
export { SpaceItem };
